import React from 'react';
import moment from 'moment';
import {
  EuiSpacer,
  EuiBasicTable,
  EuiDescriptionList,
  EuiFlexItem,
  EuiFlexGroup,
  EuiListGroupItem,
  EuiListGroup,
} from 'stable-eui';
import { Tabs } from 'antd';
import TRANS from 'app-constants/trans.json';
import { CaretRightOutlined } from '@ant-design/icons';
import { get, map } from 'lodash';
import { formatMoney, getMessage } from 'utils';
import { transformTimeLineData } from './utils';

export const STATUS = {
  0: getMessage('new_status'),
  1: getMessage('processing'),
  2: getMessage('pages.common.status.finish'),
};

export const COLORS = {
  PINK: '#e91e63',
  BLUE: '#03a9f4',
};

const buildNoteDetail = (noteList) => {
  const isEmpty = get(noteList, '0.EMPTY');
  const renderList = isEmpty ? new Array(3) : noteList;
  return (
    <EuiListGroup style={{ maxWidth: 'inherit' }} className="listTimeline">
      {map(renderList, (item, index) =>
        item ? (
          <EuiListGroupItem
            size="s"
            key={index}
            style={{ marginLeft: 10, minHeight: 30, overflow: 'auto' }}
            wrapText
            label={
              item.SUB_TITLE && (
                <React.Fragment>
                  <b>{item.SUB_TITLE}</b>: {item.GHI_CHU}
                </React.Fragment>
              )
            }
          />
        ) : (
          <EuiSpacer size="m" />
        )
      )}
    </EuiListGroup>
  );
};

export default (props) => {
  const tblPhieuGuiHanhTrinhItems = get(props.data, 'tab1Data', []);
  const tab2Data = get(props.data, 'tab2Data', {});
  const tblPhieuGuiKhieuNaiItems = get(props.data, 'tab3Data', []);
  const tblPhieuGuiHanhTrinhCols = [
    {
      field: 'DATE_TITLE',
      name: getMessage('date_time'),
      width: '15%',
      className: 'date_title',
      render: (v) => <strong>{v}</strong>,
    },
    {
      field: 'GHI_CHU',
      name: getMessage('pages.common.label.info'),
      render: (_, record) => record && buildNoteDetail(record.ITEMS),
      width: '85%',
    },
  ];

  const tblPhieuGuiKhieuNaiCols = [
    {
      field: 'ID_KHIEUNAI',
      name: getMessage('complaint_code'),
      sortable: true,
      width: '10%',
    },
    {
      field: 'NGAY_TAO',
      name: getMessage('date_created'),
      sortable: true,
      width: '10%',
      render: (v) => moment(v).format('DD-MM-YYYY HH:mm'),
    },
    {
      field: 'NOI_DUNG',
      name: getMessage('content'),
      sortable: true,
    },
    {
      field: 'KETQUA_XULY',
      name: getMessage('process_result'),
      sortable: true,
      width: '30%',
    },
    {
      field: 'TRANG_THAI',
      name: getMessage('pages.common.table.status'),
      sortable: true,
      width: '10%',
      render: (v) => STATUS[v] || getMessage('new_status'),
    },
  ];

  const tabsPhieuGuiContentHanhTrinh = (
    <EuiBasicTable
      className="table-timeline"
      items={transformTimeLineData(tblPhieuGuiHanhTrinhItems)}
      rowHeader="ID"
      noItemsMessage={getMessage('no_display_information_found')}
      columns={tblPhieuGuiHanhTrinhCols}
    />
  );

  const tabsPhieuGuiContentThongTin1 = [
    {
      title: getMessage('pages.common.table.status'),
      description: (
        <b style={{ color: COLORS.BLUE }}>
          {getMessage(TRANS.ORDER_STATUS.REMAP[tab2Data.status])}
        </b>
      ),
    },
    {
      title: getMessage('date_created'),
      description: (
        <span className="secondary_desc">
          {moment(get(tab2Data, 'date_create', '')).format(
            getMessage('pages.common.format.date_time')
          )}
        </span>
      ),
    },
    // {
    //   title: getMessage('partner'),
    //   description: (
    //     <span className="secondary_desc">
    //       {get(tab2Data, 'MA_DOITAC1', '')}
    //     </span>
    //   ),
    // },
    {
      title: `${getMessage('pages.common.label.weight')}`,
      description: (
        <div style={{ color: COLORS.PINK }}>
          {/* <span>{get(tab2Data, 'MA_DV_VIETTEL', '')}</span> / */}
          <span>{` ${formatMoney(
            get(tab2Data, 'parcel_weight', 0) / 1000,
            2
          )} kg`}</span>
        </div>
      ),
    },

    // {
    //   title: `${getMessage('total_money')}`,
    //   description: (
    //     <>
    //       <span>{get(tab2Data, 'TONG_TIEN', 0)}</span>
    //     </>
    //   ),
    // },
    // {
    //   title: getMessage('additional_service'),
    //   description: (
    //     <span className="secondary_desc">{get(tab2Data, 'DVCT', '')}</span>
    //   ),
    // },
  ];

  const tabsPhieuGuiContentThongTin2 = [
    {
      title: getMessage('tofu_order_code'),
      description: get(tab2Data, 'code', ''),
    },

    {
      title: getMessage('sender'),
      description: (
        <span className="secondary_desc">
          {get(tab2Data, 'customer_code', '')} -{' '}
          {get(tab2Data, 'customer_name', '')}
        </span>
      ),
    },

    {
      title: getMessage('pages.common.label.note'),
      description: get(tab2Data, 'note', ''),
    },
  ];
  const tabsPhieuGuiContentThongTin3 = [
    {
      title: getMessage('common.label.parcel_type'),
      description: getMessage(
        TRANS.PARCEL_TYPE_MASTER.REMAP[get(tab2Data, 'parcel_type')]
      ),
    },
    {
      title: getMessage('pages.common.label.receiver_address'),
      description: get(tab2Data, 'address', ''),
    },

    {
      title: getMessage('pages.order.table.receiver_phone'),
      description: (
        <span className="secondary_desc">{get(tab2Data, 'phone', '')}</span>
      ),
    },

    // {
    //   title: getMessage('full_name_of_recipient'),
    //   description: (
    //     <span className="secondary_desc">
    //       {get(tab2Data, 'TEN_KHNHAN', '')}
    //     </span>
    //   ),
    // },
  ];

  const tabsPhieuGuiContentKhieuNai = (
    <EuiBasicTable
      items={tblPhieuGuiKhieuNaiItems || []}
      rowHeader="ID"
      noItemsMessage={getMessage('no_display_information_found')}
      columns={tblPhieuGuiKhieuNaiCols}
    />
  );

  return (
    <Tabs defaultActiveKey="1">
      <Tabs.TabPane
        tab={
          <span>
            <CaretRightOutlined />
            {getMessage('journeys')}
          </span>
        }
        key="1"
      >
        {tabsPhieuGuiContentHanhTrinh}
      </Tabs.TabPane>
      <Tabs.TabPane
        tab={
          <span>
            <CaretRightOutlined />
            {getMessage('information')}
          </span>
        }
        key="2"
      >
        <EuiFlexGroup style={{ paddingTop: 20, paddingLeft: 20 }}>
          <EuiFlexItem>
            <EuiDescriptionList
              compressed
              textStyle="reverse"
              listItems={tabsPhieuGuiContentThongTin1}
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiDescriptionList
              compressed
              textStyle="reverse"
              listItems={tabsPhieuGuiContentThongTin2}
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiDescriptionList
              compressed
              textStyle="reverse"
              listItems={tabsPhieuGuiContentThongTin3}
            />
          </EuiFlexItem>
        </EuiFlexGroup>
      </Tabs.TabPane>
      <Tabs.TabPane
        tab={
          <span>
            <CaretRightOutlined />
            {getMessage('complain')}
          </span>
        }
        key="3"
      >
        {tabsPhieuGuiContentKhieuNai}
      </Tabs.TabPane>
    </Tabs>
  );
};
